<template>
  <div class="fw-bolder">
    <div class="position-relative">
      <div class="flex-grow-1 text-start justify-content-between cursor-pointer d-flex align-items-center w-100 position-relative" @click.stop="toggle">
        <div v-if="empty(value)" class="form-control form-select">
          Aucun partenaire
        </div>
        <template v-else>
          <div class="w-100 overflow-auto d-flex ">
            <UserView v-model="value"/>
          </div>
        </template>
      </div>
      <div v-if="open" ref="menu" class="p-5 min-w-300px shadow-lg bg-white position-absolute rounded" style="top:100%;right:0;z-index: 20">
        <div class="overflow-auto border-rounded " style="max-height: 250px;">
          <div class="p-1 d-flex gap-2 position-sticky top-0 bg-white">
            <input v-model="filter.content" class="form-control" placeholder="Rechercher" type="text" @input="onSearchInput"/>
            <div class="flex-1">
              <div class="btn btn-primary btn-icon btn-sm" @click="search">
                <i class="fad fa-search"></i>
              </div>
            </div>
          </div>
          <div v-if="!isLoading && empty(users)" class="px-3 py-5 border-top">
            <div class="d-flex flex-column justify-content-center align-items-center">
              <i class="fad fa-empty-set fs-3x"></i>
              <div class="text-muted">
                Aucun partenaire correspondante
              </div>
            </div>
          </div>
          <div v-if="!isLoading" class="py-5 text-left">
            <template v-for="user of users">
              <template>
                <div class="bg-hover-light-primary px-3 py-2 border-top" @click="setUser(user)">
                  <div class="fw-bolder">
                    {{ user.name }} {{ user.prename }}
                  </div>
                  <div class="fw-bolder text-muted fs-8">
                    {{ user.email }}
                  </div>
                </div>
              </template>
            </template>
          </div>
          <template v-else>
            <Loading/>
          </template>
        </div>

        <CustomPagination :currentPage="filter.page"
                          :itemsPerPage="filter.perPage"
                          :matchCount="matchCount"
                          :totalItems="users.length"
                          class="mt-5"
                          @update:currentPage="search"
        />
      </div>
    </div>
  </div>


</template>


<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {api} from "@/services/Api";
import Loading from "@/components/Loading.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import Pagination from "@/components/Pagination.vue";
import UserView from "@/components/UserView.vue";

@Component({
  components: {UserView, Pagination, CustomPagination, Loading}
})
export default class UserSelector extends Vue {
  @Prop({default: ''}) value?: string;
  users: any[] = []
  filter = {
    page: 1,
    perPage: 50,
    content: ''
  }
  user: any = null
  isLoading = false
  open = false
  timeout = null
  matchCount = 0
  total = 0


  @Watch('value')
  update(){
    console.log(this.value)
  }
  mounted() {
    this.$addListener(window, 'click', this.closeMenu, false)
  }


  closeMenu(event) {
    const menu = this.$refs.menu as any
    if (menu && !menu.contains(event.target) && this.open) {
      this.open = false
      console.log('Click en dehors détecté')
    }
  }

  toggle() {
    this.open = !this.open
  }

  onSearchInput() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      if (!this.filter.content || this.filter.content.length < 2) return
      this.search()
    }, 800)
  }

  async search(page = null) {
    if (page && !isNaN(page)) {
      this.filter.page = page
    }
    this.isLoading = true
    const res = await api.post(api.auth, 'user/search', this.filter)
    this.isLoading = false
    if (res?.data?.users) {
      this.$set(this, 'users', res.data.users)
      this.matchCount = res.data.matchCount
      this.total = res.data.total
    }
  }

  setUser(user) {
    console.log(user)
    this.user = user
    this.filter.content = ''
    this.filter.page = 1
    this.$emit('input', user.email)
    this.$emit('user', user)
    this.open = false
  }

}
</script>


<style scoped>

</style>
